import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  Typography,
  Checkbox,
  Button,
  Box,
  Stack,
  FormControlLabel,
  Divider,
  Collapse,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { updateManageCredits } from "../../../services/hospitalServices";
import { setPhoto } from "../../../layouts/events/Redux/actionCreator";
import { toast } from "react-toastify";
import ConfirmDialog from "layouts/hospital/ConfirmDialog";

export default function ManualRechargeUI({ responseData, onRefresh,setTab }) {
  const dispatch = useDispatch();

  console.log("responseData22", responseData);
  // Local state for showing updated values
  const [walletData, setWalletData] = useState(responseData);

  const [amount, setAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [date, setDate] = useState(null);
  const [file, setFile] = useState(null);
  const [narration, setNarration] = useState("");
  const [remark, setRemark] = useState("");
  const [isFilledTopUp, setIsFilledTopUp] = useState(false);
  const [isAmountChanged, setIsAmountChanged] = useState(false);
  const [isPaymentMethodChanged, setIsPaymentMethodChanged] = useState(false);
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [isFileChanged, setIsFileChanged] = useState(false);
  const [isNarrationChanged, setIsNarrationChanged] = useState(false);
  const [isRemarkChanged, setIsRemarkChanged] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
const [confirmMessage, setConfirmMessage] = useState("");
const [pendingAction, setPendingAction] = useState(null);

  // Adjustment States
  const [adjustCredits, setAdjustCredits] = useState(false);
  const [adjustmentType, setAdjustmentType] = useState("");
  const [adjustmentAmount, setAdjustmentAmount] = useState("");
  const [adjustmentRemark, setAdjustmentRemark] = useState("");
  const [adjustmentFile, setAdjustmentFile] = useState(null);
  const [isAdjustmentTypeChanged, setIsAdjustmentTypeChanged] = useState(false);
  const [isAdjustmentAmountChanged, setIsAdjustmentAmountChanged] =
    useState(false);
    const [isAdjustmentRemarkChanged , setIsAdjustmentRemarkChanged] = useState(false);
  const [isAdjustmentFileChanged, setIsAdjustmentFileChanged] = useState(false);
  const [isFilledAdjustment, setIsFilledAdjustment] = useState(false);

  const [defaultValues, setDefaultValues] = useState({
    amount: "",
    paymentMethod: "",
    date: "",
    file: null,
  });

  const [defaultAdjudtValues, setDefaultAdjustValues] = useState({
    adjustmentType: "",
    adjustmentAmount: "",
    adjustmentFile: null,
  });

  // const currentBalance = 125000;
  console.log("isAmountChanged", isAmountChanged);
  const currentBalance = responseData?.prepaidWallet?.amountAvailable || 0;
  const newBalance = isAmountChanged
    ? currentBalance + Number(amount)
    : currentBalance;
    const adjustedNewBalance =
    adjustmentType === "CREDIT_NOTE"
      ? currentBalance + Number(adjustmentAmount || 0)
      : adjustmentType === "DEBIT_NOTE"
      ? currentBalance - Number(adjustmentAmount || 0)
      : currentBalance;

  console.log("walletData", walletData);
  console.log("file", file);
  const cleanObject = (obj) => {
    return Object.entries(obj)
      .filter(([_, v]) => v !== "" && v !== null && v !== undefined)
      .reduce((acc, [k, v]) => {
        acc[k] =
          typeof v === "object" && !Array.isArray(v) ? cleanObject(v) : v;
        return acc;
      }, {});
  };

  const handleTopUpSubmit = async () => {
    console.log("inside handleTopUpSubmit");
    const payload = {
      prepaidWallet: {
        ...(isAmountChanged && { amountDeposit: amount }),
        ...(isPaymentMethodChanged && { paymentMethods: paymentMethod }),
        ...(isDateChanged && { depositDate: date }),
        ...(isFileChanged && { paymentAttachment: file }),
        ...(isNarrationChanged && { Narration: narration }),
        ...(isRemarkChanged && {remarks: remark}),

        ...(adjustCredits && {
          adjustCredits: {
            ...({ adjustmentType }),
            ...({ amount: adjustmentAmount }),
            ...(isAdjustmentFileChanged && { attachment: adjustmentFile }),
            ...(adjustCredits && { isAdjusted: adjustCredits }),
            ...(adjustmentRemark && { remarks: adjustmentRemark }),
          },
        }),
      },
    };

    const finalPayload = cleanObject(payload);

    console.log("finalPayload", finalPayload);

    try {
      const updatedData = await updateManageCredits({
        id: responseData?._id,
        payload: finalPayload,
      });

      console.log("UPDATED DATA:", updatedData);

      console.log("RES_TYPE:", typeof updatedData);

      if (updatedData?.data?.status === true) {
        toast.success("Added successful", { position: "top-right" });
         if (onRefresh) onRefresh();
          setTab(1);
        setAmount(updatedData?.data?.data?.prepaidWallet?.amountDeposit);
        setPaymentMethod(
          updatedData?.data?.data?.prepaidWallet?.paymentMethods
        );
        setDate(
          formatForInput(updatedData?.data?.data?.prepaidWallet?.depositDate)
        );
        setFile(updatedData?.data?.data?.prepaidWallet?.paymentAttachment);
        setNarration(updatedData?.data?.data?.prepaidWallet?.Narration);
        setRemark(updatedData?.data?.data?.prepaidWallet?.remarks);
        setIsFilledTopUp(false);
        setIsAmountChanged(false);

        //adjust
        setAdjustmentType(
          updatedData?.data?.data?.prepaidWallet?.adjustCredits?.adjustmentType
        );
        setAdjustmentAmount(
          updatedData?.data?.data?.prepaidWallet?.adjustCredits?.amount
        );
        setAdjustmentFile(
          updatedData?.data?.data?.prepaidWallet?.adjustCredits?.attachment
        );
        setIsFilledAdjustment(false);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const formatForInput = (ts) => {
    const d = new Date(Number(ts));
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const amount = responseData?.prepaidWallet?.amountDeposit || "";
    const paymentMethod = responseData?.prepaidWallet?.paymentMethods || "";
    const today = new Date().toISOString().split("T")[0];
    const date = responseData?.prepaidWallet?.depositDate
      ? formatForInput(responseData.prepaidWallet.depositDate)
      : today;
    const file = responseData?.prepaidWallet?.paymentAttachment || "";
    const narration = responseData?.prepaidWallet?.Narration || "";
    const remark = responseData?.prepaidWallet?.remarks || "";

    setDefaultValues({ amount, paymentMethod, date, file, narration  , remark});

    setAmount(amount);
    setPaymentMethod(paymentMethod);
    setDate(date);
    setFile(file);
    setNarration(narration);
    setRemark(remark);

    //adjsut
    const adjustmentType =
      responseData?.prepaidWallet?.adjustCredits?.adjustmentType || "";
    const adjustmentAmount =
      responseData?.prepaidWallet?.adjustCredits?.amount || "";
    const adjustmentFile =
      responseData?.prepaidWallet?.adjustCredits?.attachment || "";
    setDefaultAdjustValues({
      adjustmentType,
      adjustmentAmount,
      adjustmentFile,
    });
    setAdjustmentType(adjustmentType);
    setAdjustmentAmount(adjustmentAmount);
    setAdjustmentFile(adjustmentFile);
  }, [responseData]);

  const handleTopUpCancel = () => {
    setAmount(defaultValues.amount);
    setPaymentMethod(defaultValues.paymentMethod);
    setDate(defaultValues.date);
    setFile(defaultValues.file);
    setNarration(defaultValues.narration);
    setRemark(defaultValues.remark);
    setIsFilledTopUp(false);
  };

  const handleAdjustCancel = () => {
    setAdjustmentType(defaultAdjudtValues.adjustmentType);
    setAdjustmentAmount(defaultAdjudtValues.adjustmentAmount);
    setAdjustmentFile(defaultAdjudtValues.adjustmentFile);
    setIsFilledAdjustment(false);
  };
  const handleConfirm = async () => {
    setOpenConfirm(false);
  
    await handleTopUpSubmit();
  };
  const handleCancel = () => {
    setOpenConfirm(false);
  
    if (pendingAction === "TOPUP") {
      handleTopUpCancel();
    }
  
    if (pendingAction === "ADJUST") {
      handleAdjustCancel();
    }
  };

  const handleFileTopUpUpload = async (e) => {
    if (isFilledAdjustment) {
      toast.error("Please clear or submit your adjustment first");
      return;
    }
    setIsFilledTopUp(true);
    setIsFileChanged(true);
    const { name, value, files } = e.target;
    console.log("files", files);
    if (files && files[0]) {
      const file = files[0];
      console.log("file22", file);
      dispatch(setPhoto(file))
        .then((response) => {
          const logoUrl = response.payload.data.data[0].url;
          console.log("logoUrl", logoUrl);
          setFile(logoUrl);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          // Handle error
        });
    }
  };
  const formatDisplayDate = (inputDate) => {
    if (!inputDate) return "";
    return new Date(inputDate).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

const handleOpenConfirm = () => {
    const hospitalName = responseData?.jobLocation?.hospitalName || "";
  
    if (adjustCredits) {
      setConfirmMessage(
        `You will ${adjustmentType === "CREDIT_NOTE" ? "credit" : "debit"} ₹${adjustmentAmount}
         for ${hospitalName} • New Balance: ₹${adjustedNewBalance}`
      );
      setPendingAction("ADJUST");
    } else {
      setConfirmMessage(
        `You will add ₹${amount} via ${paymentMethod}
         for ${hospitalName} • New Balance: ₹${newBalance}
         • Effective: ${formatDisplayDate(date)}`
      );
      setPendingAction("TOPUP");
    }
  
    setOpenConfirm(true);
  };

  const handleFileAdjustUpload = async (e) => {
    setIsAdjustmentFileChanged(true);
    setIsFilledAdjustment(true);
    const { name, value, files } = e.target;
    console.log("files", files);
    if (files && files[0]) {
      const file = files[0];
      console.log("file22", file);
      dispatch(setPhoto(file))
        .then((response) => {
          const logoUrl = response.payload.data.data[0].url;
          console.log("logoUrl", logoUrl);
          setAdjustmentFile(logoUrl);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          // Handle error
        });
    }
  };

  console.log("fileData", file);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ pt: 3, pr: 5, pl: 2 }}>
        {/* Page Title */}
        {/* <Typography variant="h5" fontWeight={600} mb={3}>
          Manual Recharge – Mumbai Branch
        </Typography> */}

        <Card
          elevation={2}
          sx={{
            borderRadius: 3,
            boxShadow: "0px 3px 12px rgba(0,0,0,0.08)",
          }}
        >
          <CardContent sx={{ p: 3 }}>
          {!adjustCredits && (
  <>
            <Typography variant="h6" fontWeight={600} mb={1}>
              Top-up Wallet
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              {/* Amount Received */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Amount Received"
                  type="number"
                  value={amount}
                  // onChange={(e) => setAmount(e.target.value)}
                  onChange={(e) => {
                    if (isFilledAdjustment) {
                      toast.error(
                        "Please clear or submit your adjustment first"
                      );
                      return;
                    }
                    setAmount(e.target.value);
                    setIsAmountChanged(true);
                    setIsFilledTopUp(true);
                  }}
                  InputProps={{
                    sx: { borderRadius: 2, height: 56 },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Date */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Date"
                  type="date"
                  value={date}
                  // onChange={(e) => setDate(e.target.value)}
                  onChange={(e) => {
                    if (isFilledAdjustment) {
                      toast.error(
                        "Please clear or submit your adjustment first"
                      );
                      return;
                    }
                    setDate(e.target.value);
                    setIsDateChanged(true);
                    setIsFilledTopUp(true);
                  }}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    sx: { borderRadius: 2, height: 56 },
                  }}
                />
              </Grid>

              {/* Payment Method - Styled like TextField */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel
                    shrink
                    sx={{
                      // color: "#1976d2",
                      fontWeight: 500,
                      fontSize: "0.875rem",
                    }}
                  >
                    Select payment method
                  </InputLabel>

                  <Select
                    value={paymentMethod}
                    // onChange={(e) => setPaymentMethod(e.target.value)}
                    onChange={(e) => {
                      if (isFilledAdjustment) {
                        toast.error(
                          "Please clear or submit your adjustment first"
                        );
                        return;
                      }
                      setPaymentMethod(e.target.value);
                      setIsPaymentMethodChanged(true);
                      setIsFilledTopUp(true);
                    }}
                    label="Select payment method"
                    displayEmpty
                    sx={{
                      borderRadius: 2,
                      height: 56,

                      "& .MuiSelect-select": {
                        padding: "16.5px 14px",
                        color: paymentMethod ? "inherit" : "transparent",
                        caretColor: "transparent",
                      },

                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.87)",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#1976d2",
                        borderWidth: 2,
                      },
                    }}
                  >
                    <MenuItem value="cash">Cash</MenuItem>
                    <MenuItem value="upi">UPI</MenuItem>
                    <MenuItem value="bank_transfer">Bank Transfer</MenuItem>
                    <MenuItem value="cheque">Cheque</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* File Upload */}
              <Grid item xs={12}>
                {/* Hidden input */}
                <input
                  id="file-upload"
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: "none" }}
                  onChange={handleFileTopUpUpload}
                />

                {/* ─────────────── CASE 1: NO FILE UPLOADED ─────────────── */}
                {!file ? (
                  <Box
                    onClick={() =>
                      document.getElementById("file-upload").click()
                    }
                    // sx={{
                    //   border: "2px dashed #d0d7de",
                    //   borderRadius: 2,
                    //   p: 4,
                    //   textAlign: "center",
                    //   cursor: "pointer",
                    //   bgcolor: "#fafafa",
                    // }}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px dashed #d0d7de",
                      borderRadius: "8px",
                      p: 1,
                      cursor: "pointer",
                      backgroundColor: "#fafafa",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "#f0f4ff",
                        borderColor: "#1976d2",
                      },
                      position: "relative",
                    }}
                  >
                    <Box sx={{ fontSize: 26, color: "#1976d2", mb: 1 }}>☁️</Box>

                    <Typography
                      variant="body1"
                      sx={{ color: "#444", fontWeight: 500 }}
                    >
                      Click to upload
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      PDF, JPG, PNG up to 10MB
                    </Typography>
                  </Box>
                ) : (
                  /* ─────────────── CASE 2: FILE UPLOADED ─────────────── */
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      border: "2px dashed #90caf9",
                      borderRadius: 2,
                      bgcolor: "#f5faff",
                      p: 1,
                    }}
                  >
                    <Typography fontWeight={600} mb={2}>
                      Uploaded: {file?.split("/").pop()}
                    </Typography>

                    <Box sx={{ display: "flex", gap: 2 }}>
                      {/* CHANGE BUTTON */}
                      <Button
                        variant="outlined"
                        onClick={() =>
                          document.getElementById("file-upload").click()
                        }
                        sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          borderColor: "#ccc",
                          ":hover": {
                            backgroundColor: "#f5f5f5",
                            borderColor: "#999",
                          },
                        }}
                      >
                        Change
                      </Button>

                      {/* VIEW BUTTON */}
                      <Button
                        variant="contained"
                        onClick={() => window.open(file, "_blank")}
                        // sx={{ textTransform: "none", borderRadius: 2 }}
                      >
                        View
                      </Button>
                    </Box>
                  </Box>
                )}
              </Grid>

              {/* <Grid item xs={12}>
                <label htmlFor="file-upload">
                  <input
                    id="file-upload"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    style={{ display: "none" }}
                    // onChange={(e) => setFile(e.target.files[0])}
                    onChange={handleFileTopUpUpload}
                  />
                  <Box
                    sx={{
                      border: "2px dashed #90caf9",
                      borderRadius: 3,
                      p: 4,
                      textAlign: "center",
                      cursor: "pointer",
                      bgcolor: "#f7fbff",
                      transition: "all 0.2s",
                      "&:hover": {
                        bgcolor: "#ecf5ff",
                        borderColor: "#42a5f5",
                      },
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={500}
                      color="text.secondary"
                    >
                      Click to Upload (PDF, JPG, PNG - Max 5MB)
                    </Typography>
                    {file && (
                      <Typography mt={1} color="success.main" fontWeight={600}>
                        Uploaded: {file}
                      </Typography>
                    )}
                  </Box>
                </label>
              </Grid> */}

              {/* Narration */}
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  label="Narration"
                  multiline
                  rows={3}
                  maxRows={6}
                  value={narration}
                  onChange={(e) => {
                    setNarration(e.target.value);
                    setIsNarrationChanged(true);
                    setIsFilledTopUp(true);
                  }}
                  InputProps={{
                    sx: { borderRadius: 2, minHeight: 80 },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Remarks */}
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  label="Remarks"
                  multiline
                  rows={3}
                  maxRows={6}
                  value={remark}
                  onChange={(e) => {
                    setRemark(e.target.value);
                    setIsRemarkChanged(true);
                    setIsFilledTopUp(true);
                  }}
                  InputProps={{
                    sx: { borderRadius: 2, minHeight: 80 },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Wallet Impact Preview */}
              <Grid item xs={12}>
                <Card
                  sx={{
                    bgcolor: "#f8fbff",
                    borderRadius: 3,
                    borderLeft: "5px solid #1976d2",
                    p: 2,
                  }}
                  elevation={0}
                >
                  <CardContent sx={{ py: 2, "&:last-child": { pb: 2 } }}>
                    <Typography variant="subtitle1" fontWeight={700} mb={2}>
                      Wallet Impact Preview
                    </Typography>
                    <Stack spacing={1.5}>
                      <Box display="flex" justifyContent="space-between">
                        <Typography color="text.secondary">
                          Current Balance:
                        </Typography>
                        <Typography fontWeight={700} color="primary">
                          ₹{currentBalance.toLocaleString("en-IN")}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <Typography color="text.secondary">
                          New Balance:
                        </Typography>
                        <Typography fontWeight={700} color="success.main">
                          ₹{newBalance.toLocaleString("en-IN")}
                        </Typography>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

              {/* add submit Buttons for topUp */}
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                  <Button
                    variant="outlined"
                    onClick={handleTopUpCancel}
                    sx={{
                      borderRadius: 2,
                      px: 4,
                      py: 1.2,
                      textTransform: "none",
                      fontWeight: 600,
                      backgroundColor: "#fff",
                      color: "#000",
                      borderColor: "#ccc",
                      ":hover": {
                        backgroundColor: "#f5f5f5",
                        borderColor: "#999",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      px: 4,
                      py: 1.2,
                      textTransform: "none",
                      fontWeight: 600,
                      boxShadow: "0px 4px 12px rgba(25,118,210,0.3)",
                    }}
                    disabled={!isFilledTopUp || isFilledAdjustment}
                    onClick={handleOpenConfirm}
                  >
                    Add Top Up
                  </Button>
                </Box>
              </Grid>  
              </Grid>
  </>
)}
              {/* Enable Adjust Credits Checkbox */}
<Grid>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Checkbox
                    checked={adjustCredits}
                    // onChange={(e) => setAdjustCredits(e.target.checked)}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      if (isFilledTopUp) {
                        e.preventDefault();
                        toast.error(
                          "Please clear or submit your current top-up first"
                        );
                        return;
                      }
                      setAdjustCredits(e.target.checked);
                      if (checked) {
                        setAdjustmentType("");
                        setAdjustmentAmount("");
                        setAdjustmentFile(null);
                        setAdjustmentRemark("")
                        setIsFilledAdjustment(false);
                      } else {
                        handleAdjustCancel();
                      }
                    }}
                    color="primary"
                  />
                  <Typography
                    fontWeight={500}
                    color={adjustCredits ? "primary" : "text.primary"}
                  >
                    Enable Adjust Credits
                  </Typography>
                </Box>
              </Grid>

              {/* Adjustment Form – Only shows when checkbox is checked */}
              <Grid item xs={12}>
                <Collapse in={adjustCredits} timeout="auto" unmountOnExit>
                  <Box
                    sx={{
                      mt: 3,
                      ml: { xs: 0, sm: 4 },
                      pl: { xs: 0, sm: 4 },
                      pr: { xs: 0, sm: 2 },
                      py: 3,
                      borderLeft: "2px solid #1976d2",
                      backgroundColor: "#f8fbff",
                      borderRadius: "0 12px 12px 0",
                      position: "relative",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: "4px",
                        backgroundColor: "#1976d2",
                      },
                    }}
                  >
                    <Grid container spacing={3}>
                      {/* Adjustment Type */}
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <InputLabel
                            shrink
                            sx={{
                              color: "#1976d2",
                              fontWeight: 600,
                              fontSize: "0.95rem",
                              backgroundColor: "#f8fbff",
                              px: 0.5,
                            }}
                          >
                            Adjustment Type *
                          </InputLabel>
                          <Select
                            value={adjustmentType}
                            onChange={(e) => {
                              setAdjustmentType(e.target.value);
                              setIsAdjustmentTypeChanged(true);
                              {isAdjustmentAmountChanged && setIsFilledAdjustment(true);}
                            }}
                            label="Adjustment Type *"
                            displayEmpty
                            sx={{
                              borderRadius: 3,
                              height: 56,
                              backgroundColor: "white",
                              "& .MuiSelect-select": {
                                padding: "16.5px 14px",
                              },
                            }}
                          >
                            <MenuItem value="" disabled>
                              <em>Select adjustment type</em>
                            </MenuItem>
                            <MenuItem value="CREDIT_NOTE">Credit Note</MenuItem>
                            {/* <MenuItem value="DISCOUNT">Discount</MenuItem>
                            <MenuItem value="REFUND">Refund</MenuItem> */}
                            <MenuItem value="DEBIT_NOTE">Debit Note</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* Amount */}
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Amount *"
                          type="number"
                          value={adjustmentAmount}
                          onChange={(e) => {
                            setAdjustmentAmount(e.target.value);
                            setIsAdjustmentAmountChanged(true);
                            {isAdjustmentTypeChanged && setIsFilledAdjustment(true);}
                          }}
                          placeholder="Enter adjustment amount"
                          InputLabelProps={{
                            shrink: true,
                            sx: {
                              color: "#1976d2",
                              fontWeight: 600,
                              fontSize: "0.95rem",
                              backgroundColor: "white",
                              px: 0.5,
                            },
                          }}
                          InputProps={{
                            sx: {
                              borderRadius: 3,
                              height: 56,
                              backgroundColor: "white",
                            },
                          }}
                        />
                      </Grid>

                      {/* Attachment (Optional) */}
                      <Grid item xs={12}>
                        <Typography
                          variant="body1"
                          fontWeight={500}
                          color="text.primary"
                          mb={1.5}
                          sx={{ ml: 1 }}
                        >
                          Attachment (Optional)
                        </Typography>
                        {/* <label htmlFor="adjustment-file"> */}
                        <input
                          id="adjustment-file"
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          style={{ display: "none" }}
                          onChange={handleFileAdjustUpload}
                        />
                        {/* ─────────────── CASE 1: NO FILE UPLOADED ─────────────── */}
                        {!adjustmentFile ? (
                          <Box
                            onClick={() =>
                              document.getElementById("adjustment-file").click()
                            }
                            // sx={{
                            //   border: "2px dashed #d0d7de",
                            //   borderRadius: 2,
                            //   p: 4,
                            //   textAlign: "center",
                            //   cursor: "pointer",
                            //   bgcolor: "#fafafa",
                            // }}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "2px dashed #d0d7de",
                              borderRadius: "8px",
                              p: 1,
                              cursor: "pointer",
                              backgroundColor: "#fafafa",
                              transition: "all 0.2s ease-in-out",
                              "&:hover": {
                                backgroundColor: "#f0f4ff",
                                borderColor: "#1976d2",
                              },
                              position: "relative",
                            }}
                          >
                            <Box sx={{ fontSize: 26, color: "#1976d2", mb: 1 }}>
                              ☁️
                            </Box>

                            <Typography
                              variant="body1"
                              sx={{ color: "#444", fontWeight: 500 }}
                            >
                              Click to upload
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                              PDF, JPG, PNG up to 10MB
                            </Typography>
                          </Box>
                        ) : (
                          /* ─────────────── CASE 2: FILE UPLOADED ─────────────── */
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              border: "2px dashed #90caf9",
                              borderRadius: 2,
                              bgcolor: "#f5faff",
                              p: 1,
                            }}
                          >
                            <Typography fontWeight={600} mb={2}>
                              Uploaded: {adjustmentFile?.split("/").pop()}
                            </Typography>

                            <Box sx={{ display: "flex", gap: 2 }}>
                              {/* CHANGE BUTTON */}
                              <Button
                                variant="outlined"
                                onClick={() =>
                                  document
                                    .getElementById("adjustment-file")
                                    .click()
                                }
                                sx={{
                                  backgroundColor: "#fff",
                                  color: "#000",
                                  borderColor: "#ccc",
                                  ":hover": {
                                    backgroundColor: "#f5f5f5",
                                    borderColor: "#999",
                                  },
                                }}
                              >
                                Change
                              </Button>

                              {/* VIEW BUTTON */}
                              <Button
                                variant="contained"
                                onClick={() =>
                                  window.open(adjustmentFile, "_blank")
                                }
                                // sx={{ textTransform: "none", borderRadius: 2 }}
                              >
                                View
                              </Button>
                            </Box>
                          </Box>
                        )}
                        {/* </label> */}
                      </Grid>
                              {/* Remark */}
                              <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Remark"
                          value={adjustmentRemark}
                          onChange={(e) => {
                            setAdjustmentRemark(e.target.value);
                            setIsAdjustmentRemarkChanged(true);
                            // setIsFilledAdjustment(true);
                          }}
                          placeholder="Enter adjustment remark"
                          InputLabelProps={{
                            shrink: true,
                            sx: {
                              color: "#1976d2",
                              fontWeight: 600,
                              fontSize: "0.95rem",
                              backgroundColor: "white",
                              px: 0.5,
                            },
                          }}
                          InputProps={{
                            sx: {
                              borderRadius: 3,
                              height: 56,
                              backgroundColor: "white",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  
   <Grid item xs={12 } sx={{  marginTop:5}}>
                <Card
                  sx={{
                    bgcolor: "#f8fbff",
                    borderRadius: 3,
                    // borderLeft: "5px solid #1976d2",
                    p: 2,
                  }}
                  elevation={0}
                >
                  <CardContent sx={{ py: 2, "&:last-child": { pb: 2 } }}>
                    <Typography variant="subtitle1" fontWeight={700} mb={2}>
                      Wallet Impact Preview
                    </Typography>
                    <Stack spacing={1.5}>
                      <Box display="flex" justifyContent="space-between">
                        <Typography color="text.secondary">
                          Current Balance:
                        </Typography>
                        <Typography fontWeight={700} color="primary">
                          ₹{currentBalance.toLocaleString("en-IN")}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <Typography color="text.secondary">
                          New Balance:
                        </Typography>
                        <Typography fontWeight={700} color="success.main">
                          ₹{adjustedNewBalance.toLocaleString("en-IN")}
                        </Typography>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
                  </Box>

                  {/* add Buttons for adjusttment */}
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      gap={2}
                      mt={2}
                    >
                      <Button
                        variant="outlined"
                        // sx={{
                        // backgroundColor: "#fff",
                        // color: "#000",
                        // borderColor: "#ccc",
                        // ":hover": {
                        //   backgroundColor: "#f5f5f5",
                        //   borderColor: "#999",
                        // },
                        // }}
                        sx={{
                          borderRadius: 2,
                          px: 4,
                          py: 1.2,
                          textTransform: "none",
                          fontWeight: 600,
                          backgroundColor: "#fff",
                          color: "#000",
                          borderColor: "#ccc",
                          ":hover": {
                            backgroundColor: "#f5f5f5",
                            borderColor: "#999",
                          },
                        }}
                        onClick={handleAdjustCancel}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          borderRadius: 2,
                          px: 4,
                          py: 1.2,
                          textTransform: "none",
                          fontWeight: 600,
                          boxShadow: "0px 4px 12px rgba(25,118,210,0.3)",
                        }}
                        disabled={!isFilledAdjustment}
                        onClick={handleOpenConfirm}
                      >
                        Add Adjust Credits
                      </Button>
                    </Box>
                  </Grid>
                </Collapse>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      <ConfirmDialog
  open={openConfirm}
  title="Confirm"
  message={confirmMessage}
  onConfirm={handleConfirm}
  onCancel={handleCancel}
/>
    </LocalizationProvider>
  );
}
